<div class="modal-border">
  <ion-header>
    <ion-toolbar>
      <ion-title
        ><ion-icon name="warning-outline"></ion-icon> Warning</ion-title
      >
      <ion-buttons slot="end">
        <ion-button (click)="dismissModal()" size="large" slot="end"
          ><ion-icon name="close"></ion-icon
        ></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <p>
      This lesson has already been accessed by a user and generated training
      results, so it cannot be edited.
      <br />
      Would you like to make a copy of this lesson to make edits?
    </p>

    <ion-row>
      <ion-col class="modal-ion-col-bottom-buttons">
        <ion-button
          class="menuitem-ion-button"
          style="width: 58% !important; left: 0"
          col-6
          (click)="dismissModal()"
        >
          <ion-icon name="arrow-dropleft"></ion-icon>No
        </ion-button>
      </ion-col>
      <ion-col
        class="modal-ion-col-bottom-buttons"
        style="width: 58% !important; right: 0"
        col-6
      >
        <ion-button class="menuitem-ion-button" (click)="onCopyLesson()">
          <ion-icon name="checkmark-circle-outline"></ion-icon>Yes
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-content>
</div>
